module.exports = __webpack_public_path__ + "img/audio-description-slash.cbc2fb12.svg";